import { environment } from "./../../../environments/environment.prod";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { AccountService } from "src/app/services/account.service";
import { AlertService } from "src/app/services/alert.service";
import {
  BroadcastEventListener,
  ISignalRConnection,
  SignalR,
  SignalRConfiguration,
} from "ng2-signalr";
import { UrlConstants } from "src/app/models/urlConstants";
import { TwfaComponent } from "src/app/components/twfa/twfa.component";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { GridsterService } from "src/app/services/gridster.service";
import { ReCaptchaV3Service } from "ng-recaptcha";
import Swal from "sweetalert2";
import { Subscription } from "rxjs";
import { ForgetPassObj } from "src/app/models/login";
import { ApiService } from "src/app/services/api.service";
import { CompanySettings } from "src/app/models/company-settings";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  currentVersion = environment.version;
  formForget: FormGroup;
  remeberMe = false;
  private dsConnection: ISignalRConnection;
  private _subscription: Subscription;
  forgetPass: boolean = false;
  forgetPassObj: ForgetPassObj = {} as ForgetPassObj;
  companySettings: CompanySettings;
  tfa: any;
  isEGID = UrlConstants.isEGID;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService,
    private signalR: SignalR,
    private dialog: MatDialog,
    public translate: TranslateService,
    private gridService: GridsterService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private accService: AccountService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });
    this.isEGID ? this.GetCompanySettings() : null;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }
  get ff() {
    return this.formForget.controls;
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    if (this.form.valid) {
      this.recaptchaV3Service
        .execute("importantAction")
        .subscribe((token: string) => {
          this.accService
            .checkAuth(this.f.username.value, this.f.password.value)
            .subscribe(
              (res) => {
                this.loading = false;

                this.tfa = res;
                this.tfa.Username = this.f.username.value;

                sessionStorage.setItem("userName", this.f.username.value);
                this.twfa(this.tfa);
              },
              (err) => {
                this.loading = false;
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("login-failed-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        });
    }
  }

  twfa(data) {
    const dialogRef = this.dialog.open(TwfaComponent, {
      panelClass: "modal-container-bg",
      // disableClose: true,
      width: "350px",
      data: { data: data, remeberMe: this.remeberMe },
    });
  }

  connectOrdersSignalr() {
    let config: SignalRConfiguration = new SignalRConfiguration();
    config.url = UrlConstants.backofficeUrl;
    config.hubName = "dSHub";
    config.logging = false;

    this.signalR.connect(config).then((res) => {
      this.dsConnection = res;
      //open new tab with url
      var newTab = window.open(
        "truckscale:\\\\" + this.dsConnection.id,
        "_blank"
      );

      let method = new BroadcastEventListener<any>("dsNotify");

      this.dsConnection.listen(method);
      method.subscribe((update) => {
        if (newTab != null || newTab != undefined) {
          newTab.close();
          this.twfa(update);
        }
      });
    });
  }

  switchLang() {
    if (this.translate.currentLang == "ar") {
      this.translate.use("en");
      this.translate.setDefaultLang("en");
      this.gridService.saveLang("en");
    } else {
      this.translate.use("ar");
      this.translate.setDefaultLang("ar");
      this.gridService.saveLang("ar");
    }
    window.location.reload();
  }

  loginWithToken() {
    this.connectOrdersSignalr();
  }


  get supportNumber() {
    return UrlConstants.supportNumber;
  }

  onForget() {
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.forgetPassObj.Email = this.formForget.value.email;
        this.accService.forgetPassword(this.forgetPassObj).subscribe((arg) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: this.translate.instant("forget-msg"),
            showConfirmButton: false,
            timer: 4500,
          });
        });
      });
  }

  forgetPassword() {
    this.forgetPass = !this.forgetPass;
    if (this.forgetPass == true) {
      this.formForget = this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
      });
    }
  }

  GetCompanySettings() {
    this.apiService.GetCompanySettings()
      .subscribe(
        (data: CompanySettings) => {
          this.companySettings = data;
        }
      )
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    const element = document.getElementsByClassName(
      "grecaptcha-badge"
    )[0] as HTMLElement;
    if (element) {
      element.style.visibility = "hidden";
    }
  }
}
